import * as React from "react"
const Torch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    transform="rotate(-45)"
    viewBox="0 0 471.578 471.578"
    {...props}
  >
    <path
      d="m290.419 309.918-10.29 54.69-.51-.1h-87.37l-.79.15-10.3-54.74c-31.42-18.66-52.47-52.94-52.47-92.13h214.2c0 39.19-21.05 73.47-52.47 92.13z"
      style={{
        fill: "#f2d59f",
      }}
    />
    <path
      d="M304.549 102.298c14.83 42.66 11.8 85.72-5.01 115.49h-127.32a81.472 81.472 0 0 1-5.29-12.37 82.89 82.89 0 0 1-3.73-16.58h.01c-2.07-21.04 3.77-46.64 28-70.87 46.39-46.39 24.66-81.3 24.66-81.3h.01a59.24 59.24 0 0 0-8.95-14.28c-4.62-5.44.15-13.69 7.12-12.21 37.17 7.88 73.36 42.8 90.5 92.12zm-43.79 79.51c5.45-18.16 4.19-41.15-3.44-63.1-.45-1.3-.92-2.58-1.41-3.85-6.85 12.59-16.4 25.53-29.34 38.47-10.08 10.07-14.54 19.99-13.63 30.31.28 1.99.74 3.95 1.38 5.83.01.04.02.07.03.1 2.2 6.58 6.28 11.92 11.5 15.05.03.02.07.04.1.06 2.96 1.74 6.12 2.66 9.15 2.66 1.83 0 3.59-.31 5.38-.96.86-.31 1.72-.6 2.58-.86 10.69-3.77 15.94-17.83 17.7-23.71z"
      style={{
        fill: "#ff7124",
      }}
    />
    <path
      d="m280.129 364.608-7.96 42.27-1.59-.3h-69.29l-1.87.35-7.96-42.27.79-.15h87.37z"
      style={{
        fill: "#8ecac1",
      }}
    />
    <path
      d="m272.169 406.878-10.29 54.7h-52.18l-10.28-54.65 1.87-.35h69.29z"
      style={{
        fill: "#f2d59f",
      }}
    />
    <path
      d="M257.319 118.708c7.63 21.95 8.89 44.94 3.44 63.1-1.76 5.88-7.01 19.94-17.7 23.71-.86.26-1.72.55-2.58.86-1.79.65-3.55.96-5.38.96-3.03 0-6.19-.92-9.15-2.66-.03-.02-.07-.04-.1-.06-5.22-3.13-9.3-8.47-11.5-15.05-.01-.03-.02-.06-.03-.1a31.92 31.92 0 0 1-1.38-5.83c-.91-10.32 3.55-20.24 13.63-30.31 12.94-12.94 22.49-25.88 29.34-38.47.49 1.27.96 2.55 1.41 3.85z"
      style={{
        fill: "#8ecac1",
      }}
    />
    <path
      d="M270.579 416.578h-69.29c-5.523 0-10-4.478-10-10s4.477-10 10-10h69.29c5.522 0 10 4.478 10 10s-4.478 10-10 10zM279.619 374.507h-87.37c-5.522 0-10-4.477-10-10 0-5.522 4.478-10 10-10h87.37c5.522 0 10 4.478 10 10 0 5.523-4.478 10-10 10zM172.227 227.79a10.001 10.001 0 0 1-8.847-5.322 91.698 91.698 0 0 1-5.939-13.888 93.107 93.107 0 0 1-4.172-18.559 10.843 10.843 0 0 1-.058-.671c-1.858-19.948 2.071-49.598 30.926-78.454 39.102-39.102 24.293-67.087 23.211-68.991a9.746 9.746 0 0 1-1.061-2.166 49.209 49.209 0 0 0-6.983-10.881c-4.944-5.82-5.614-13.817-1.705-20.37 3.869-6.485 11.146-9.659 18.525-8.093 41.705 8.842 80.122 47.552 97.87 98.62 15.293 43.991 13.144 90.231-5.748 123.69-2.716 4.809-8.817 6.504-13.625 3.791-4.809-2.716-6.506-8.815-3.791-13.625 16.111-28.532 17.708-68.641 4.272-107.29-14.45-41.58-43.795-73.608-76.07-83.763a69.923 69.923 0 0 1 5.812 10.403c3.451 6.269 21.45 44.803-26.564 92.817-23.553 23.554-26.66 47.162-25.119 62.819l.018.207a73.234 73.234 0 0 0 3.229 14.17 71.893 71.893 0 0 0 4.648 10.873c2.584 4.881.723 10.933-4.158 13.518a9.957 9.957 0 0 1-4.671 1.165z"
      style={{
        fill: "#5e2a41",
      }}
    />
    <path
      d="M235.098 217.337c-4.807 0-9.723-1.396-14.218-4.04l-.038-.023-.157-.093c-7.251-4.355-12.868-11.614-15.82-20.443l-.034-.101-.054-.173a41.866 41.866 0 0 1-1.741-7.438c-.023-.17-.043-.34-.058-.511-1.171-13.267 4.389-26.141 16.523-38.263 11.557-11.558 20.852-23.73 27.623-36.175a9.963 9.963 0 0 1 9.433-5.199 10 10 0 0 1 8.681 6.376c.536 1.39 1.051 2.796 1.53 4.18 8.304 23.888 9.605 49.131 3.568 69.247-2.725 9.105-9.463 25.156-23.952 30.267a9.516 9.516 0 0 1-.433.142c-.641.193-1.322.421-2.084.695a25.263 25.263 0 0 1-8.769 1.552zm-4.044-21.258c1.394.813 2.828 1.259 4.044 1.259.677 0 1.283-.11 1.966-.358a64.056 64.056 0 0 1 2.824-.949c5.139-1.951 9.287-10.395 11.29-17.09 3.498-11.655 3.852-25.683 1.176-40.098-5.488 7.378-11.741 14.583-18.714 21.556-10.278 10.269-11.116 17.501-10.761 22.104.196 1.296.501 2.554.905 3.74l.1.309c1.448 4.233 3.958 7.593 7.081 9.476.031.015.06.033.089.051zM261.879 471.578h-52.18a10 10 0 0 1-9.828-8.151l-28.606-152.003c-1.059-5.42 2.477-10.673 7.898-11.73 5.421-1.065 10.672 2.478 11.73 7.898l.08.41 27.02 143.576h35.592l27.1-143.986c1.059-5.421 6.318-8.962 11.73-7.898 5.421 1.058 8.957 6.31 7.898 11.73l-.08.41-28.527 151.593a10 10 0 0 1-9.827 8.151z"
      style={{
        fill: "#5e2a41",
      }}
    />
    <path
      d="M290.428 319.919a9.993 9.993 0 0 1-8.607-4.896c-2.82-4.749-1.257-10.885 3.491-13.704 26.457-15.713 43.879-43.272 47.053-73.532H139.213c3.174 30.26 20.596 57.819 47.053 73.532 4.748 2.819 6.312 8.955 3.491 13.704-2.817 4.748-8.953 6.313-13.704 3.491a117.726 117.726 0 0 1-41.555-41.936c-10.342-17.781-15.809-38.111-15.809-58.791 0-5.522 4.478-10 10-10h214.199c5.522 0 10 4.478 10 10 0 20.68-5.467 41.01-15.809 58.791a117.702 117.702 0 0 1-41.555 41.936 9.938 9.938 0 0 1-5.096 1.405z"
      style={{
        fill: "#5e2a41",
      }}
    />
    <path
      d="M189.928 272.368h-46.96c-5.523 0-10-4.478-10-10s4.477-10 10-10h46.96c5.522 0 10 4.478 10 10s-4.477 10-10 10z"
      style={{
        fill: "#5e2a41",
      }}
    />
  </svg>
)
export default Torch